import RadialBarChart from './RadialBarChart'

export default RadialBarChart
